<template>
  <div class="level">
    <LevelRow
      @toggle="openCourse"
      :hasAccess="hasAccess"
      contentType="course"
      :contentId="courseId"
      :status="content.status"
      :parentStatus="parentStatus"
      :title="title"
      :plansLink="plansLink"
      :isWatching="false"
      :details="courseDetails"
      :learningArea="content.learningArea"
      :progress="progress"
      @click.native="openCourse"
    >
    </LevelRow>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'
import LevelRow from '@/components/content/level/LevelRow.vue'

export default {
  name: 'CourseLevel',
  data() {
    return {
      isLoading: false,
    }
  },
  components: {
    LevelRow,
  },
  props: {
    courseId: {
      type: String,
      required: true,
    },
    parentStatus: {
      type: String,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    content: {
      type: Object,
      required: true,
    },
    plansLink: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    courseDetails() {
      return [this.content.instructor, this.content.activities]
    },
    progress() {
      return this.content.progress * 100
    },
  },
  methods: {
    async openCourse() {
      if (this.hasAccess) {
        this.$emit('toggle-content', CONSTANTS.PLAYLIST_CONTENT_TYPES.COURSE)
        this.$router.push(
          this.$buildContentLink('course', {
            id: this.courseId,
            slug: this.content.slug,
            learning_areas: [{ name: this.content.learningArea }],
          })
        )
      }
    },
  },
}
</script>
